// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconRotateCounterClockwise = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path d="M7.386 10C8.253 7.77 10.479 6 13 6c3.232 0 6 2.741 6 6 0 3.262-2.759 6-6 6a6.05 6.05 0 01-4.243-1.757l-1.414 1.414A8.05 8.05 0 0013 20c4.34 0 8-3.629 8-8 0-4.37-3.67-8-8-8-2.995 0-5.628 1.802-6.999 4.26V4L4 6v6.001L10.002 12l2-2z" />
  );
export default SvgIconRotateCounterClockwise;
